export type ProductStatus = 
  | 'active'
  | 'sale'
  | 'sold_out'
  | 'suspended'
  | 'draft'
  | 'other'
  
  export type ProductUnit = 
  | 'kg'
  | 'unit'
  | 'carton'
  | 'pallet'
  | 'container'

export interface MediaItem {
  src: string
  type: 'image' | 'video'
}

export interface Product {
  id: string
  sku?: number
  custom_sku?: string | null
  name: string
  description: string
  price: number
  unit: ProductUnit
  quantity: number
  status: ProductStatus
  category_id: string | null
  category?: string
  images?: string[]
  supplier_id?: string
  createdAt: string
  updatedAt: string
}

export function getProductMedia(product: Product): MediaItem[] {
  return (product.images ?? []).map(src => ({
    src,
    type: /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(src) ? 'video' : 'image' as const
  }))
}